/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ls_mode_numeric = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numeric (0→9)`)
};

const es_ls_mode_numeric = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numérico (0→9)`)
};

const de_ls_mode_numeric = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numerisch (0→9)`)
};

const nl_ls_mode_numeric = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numeriek (0→9)`)
};

const fr_ls_mode_numeric = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numérique (0→9)`)
};

const it_ls_mode_numeric = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numerico (0→9)`)
};

const pt_br2_ls_mode_numeric = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numérica (0→9)`)
};

const pt_ls_mode_numeric = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numérico (0→9)`)
};

const ja_ls_mode_numeric = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数値順 (0→9)`)
};

const zh_ls_mode_numeric = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数字顺序（0→9）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ls_mode_numeric = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ls_mode_numeric(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ls_mode_numeric", locale)
	if (locale === "en") return en_ls_mode_numeric(inputs)
	if (locale === "es") return es_ls_mode_numeric(inputs)
	if (locale === "de") return de_ls_mode_numeric(inputs)
	if (locale === "nl") return nl_ls_mode_numeric(inputs)
	if (locale === "fr") return fr_ls_mode_numeric(inputs)
	if (locale === "it") return it_ls_mode_numeric(inputs)
	if (locale === "pt-BR") return pt_br2_ls_mode_numeric(inputs)
	if (locale === "pt") return pt_ls_mode_numeric(inputs)
	if (locale === "ja") return ja_ls_mode_numeric(inputs)
	return zh_ls_mode_numeric(inputs)
};